// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1utZ0","textarea":"styles_textarea__1ZqAI"};